import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Contact us", -1)
const _hoisted_2 = {
  key: 0,
  class: "subtitle-text"
}
const _hoisted_3 = { class: "required-fields-indicator-message" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "post-submit-message-title" }, " Thank You ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "post-submit-message-text" }, " Thank you for your request! A manager will contact you soon. ", -1)

import { ref, reactive, onMounted } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import { getParameter } from '../../../../../../../dow-platform/ui.frontend/src/utils/url'
import { getEloquaParameters } from '../../../../../../../dow-platform/ui.frontend/src/utils/eloqua'
import LoadingDots from '../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/commerce/shared/loading-dots'
import type { ContactUsRuleForm } from './FormInterface'
import { useStore } from 'vuex'

const requiredFieldError = 'This field is required'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUsForm',
  props: {
    contactUsForm: {
        type: Object,
        default: {},
    },
    formSize: {
        type: String,
        default: '',
    },
    elqFormName: {
        type: String,
        default: '',
    },
    elqSiteId: {
        type: String,
        default: '',
    },
    subTitle: {
        type: String,
        default: '',
    }
},
  setup(__props) {

const loading = ref(false)
const submitted = ref(false)
const submitDisabled = ref(false)
const requiredFieldsIndicatorMessage = ref('* Indicates required field')

const captchaToken = ref('')
const recaptchaInvalid = ref(false)
const recaptchaInvalidMessage = ref('An error occurred while submitting your form. Please try again in five minutes')
const formError = ref(false)

const dispatchTrackInteraction = () => {
        store.dispatch('form/trackInteraction', formComponent);
    }
const fromURLtoFORM = ref({
    campaignID: '', 
    channel: '', 
    cid: '', 
    source: '', 
    elqCampaignID: '', 
});

const props = __props;
const store = useStore()

const formComponent = Object.keys(window.adobeDataLayer.getState().component).find(key => key.includes('form'));

const contactUsFormRef = ref<FormInstance>()

const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i	

const phoneNumberRegex = /(^[(][0-9]+[)][0-9 -]+$)|(^[0-9 -]+$)|(^[+][0-9 -]+$)|(^[(][+][0-9]+[)][0-9 -]+$)/s

const nameValidator = (rule: any, field: any, callback: any) => {
    if (field.value === '') {
        callback(new Error(requiredFieldError))
        field.isError = true
    } else if (field.value.length > 255) {
        callback(new Error('Length should be less than 256'))
        field.isError = true
    } else {
        callback()
        field.isError = false
    }
}

const emailValidator = (rule: any, field: any, callback: any) => {
    if (field.value === '') {
        callback(new Error(requiredFieldError))
        field.isError = true
    } else if (!emailRegex.test(field.value)) {
        callback(new Error('Invalid email address'))
        field.isError = true
    } else {
        callback()
        field.isError = false
    }
}

const phoneValidator = (rule: any, field: any, callback: any) => {
    if (field.value !== '' && !phoneNumberRegex.test(field.value)) {
        callback(new Error('Invalid phone number'))
        field.isError = true
    } else {
        callback()
        field.isError = false
    }
}

const requiredValidator = (rule: any, field: any, callback: any) => {
    if (field.value === '') {
        callback(new Error(requiredFieldError))
        field.isError = true
    } else {
        callback()
        field.isError = false
    }
}

const selectValidator = (rule: any, field: any, callback: any) => {
    if (typeof field.value === 'string') {
        if (field.value === '') {
            callback(new Error(requiredFieldError))
            field.isError = true
        } else {
            callback()
            field.isError = false
        }
    } else {
        if (field.value.length === 0) {
            callback(new Error(requiredFieldError))
            field.isError = true
        } else {
            callback()
            field.isError = false
        }
    }
}

const contactUsFormRules = reactive<FormRules<ContactUsRuleForm>>({
    firstName: [{ validator: nameValidator, trigger: 'blur' }], 
    lastName: [{ validator: nameValidator, trigger: 'blur' }], 
    email: [{ validator: emailValidator, trigger: 'blur' }],
    country: [{ validator: selectValidator, trigger: 'change' }],
    additionalInfo: [{ validator: requiredValidator, trigger: 'blur' }],
    inquiryPurpose: [{ validator: selectValidator, trigger: 'change' }],
    productApplication: [{ validator: selectValidator, trigger: 'change' }],
    company: [{ validator: requiredValidator, trigger: 'blur' }],
    busPhone: [{ validator: phoneValidator, trigger: 'blur' }], 
})

onMounted(() => {
    initUrlQueryParameters();
})

function initUrlQueryParameters(): void {
    let cidString = getParameter('cid').toString();
    if(cidString !== ''){
        let elqFields = getEloquaParameters("cid="+cidString)
        fromURLtoFORM.value.cid = elqFields[0].value
        fromURLtoFORM.value.elqCampaignID = elqFields[1].value
        fromURLtoFORM.value.campaignID = elqFields[2].value
        fromURLtoFORM.value.channel = elqFields[3].value
        fromURLtoFORM.value.source = elqFields[4].value

    }
}

const onSubmit = async (formEl: FormInstance | undefined) => {   
    if (!formEl) { return }
    await formEl.validate((valid) => {
        if (valid) {
            formError.value = false
            postTalentForm()
        } else {
            formError.value = true
            submitDisabled.value = false
        }
    })
}

async function postTalentForm() {

    loading.value = true

    let formData : any
    formData = []

    formData.push({name: 'elqFormName', value: props.elqFormName})
    formData.push({name: 'elqSiteId', value: props.elqSiteId})
    formData.push({name: 'campaignID', value: fromURLtoFORM.value.campaignID})
    formData.push({name: 'channel', value: fromURLtoFORM.value.channel})
    formData.push({name: 'cid', value: fromURLtoFORM.value.cid})
    formData.push({name: 'source', value: fromURLtoFORM.value.source})
    formData.push({name: 'elqCampaignId', value: fromURLtoFORM.value.elqCampaignID})
    formData.push({name: 'firstName', value:  props.contactUsForm.fields.firstName.value})
    formData.push({name: 'lastName', value: props.contactUsForm.fields.lastName.value})
    formData.push({name: 'emailAddress', value: props.contactUsForm.fields.email.value})
    formData.push({name: 'country', value: props.contactUsForm.fields.country.value})
    formData.push({name: 'additionalInfo', value: props.contactUsForm.fields.additionalInfo.value})
    formData.push({name: 'busPhone', value: props.contactUsForm.fields.busPhone.value})
    formData.push({name: 'address1', value: props.contactUsForm.fields.address1.value})
    formData.push({name: 'address2', value: props.contactUsForm.fields.address2.value}) 
    formData.push({name: 'city', value: props.contactUsForm.fields.city.value})
    formData.push({name: 'stateProv', value: props.contactUsForm.fields.stateProv.value})
    formData.push({name: 'zipPostal', value: props.contactUsForm.fields.zipPostal.value})
    if(props.contactUsForm.fields.company)
        formData.push({name: 'company', value: props.contactUsForm.fields.company.value})       
    if(props.contactUsForm.fields.inquiryPurpose) 
        formData.push({name: 'inquiryPurpose', value: props.contactUsForm.fields.inquiryPurpose.value})
    if(props.contactUsForm.fields.productApplication) 
        formData.push({name: 'productApplication', value: props.contactUsForm.fields.productApplication.value})
   
    captchaToken.value = await window.grecaptcha.execute(window.captchaV3SiteKey, {action: 'ContactUsForm'})

    if (Boolean(captchaToken.value)) {
        recaptchaInvalid.value = false
        formData.push({name: 'g-recaptcha-response', value: captchaToken.value})
        await $.ajax({
            type: 'POST',
            url: '/.dow.formsub.servlet.json',
            data: $.param(formData),
            success: function (data) {
                loading.value = false
                submitted.value = true
                submitDisabled.value = false
                store.dispatch('form/trackComplete', formComponent)
            },
            error: function (data) {
                let response = data
                console.log(
                    'Contact Us Form: Error during submitting form. ' + response.responseText
                )
                store.dispatch('form/trackError', { form: formComponent, error: response.responseText })
                recaptchaInvalid.value = true
                submitDisabled.value = false
                loading.value = false
            }
        })
    } else {
        recaptchaInvalid.value = true
        submitDisabled.value = false
        loading.value = false
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "form-container" }, {
    default: _withCtx(() => [
      _createVNode(_unref(LoadingDots), { loading: loading.value }, null, 8, ["loading"]),
      _createVNode(_component_el_header, { class: "form-title" }, {
        default: _withCtx(() => [
          _hoisted_1,
          (__props.subTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("p", null, _toDisplayString(__props.subTitle), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, { class: "form-content" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(requiredFieldsIndicatorMessage.value), 1),
            _createVNode(_component_el_form, {
              ref_key: "contactUsFormRef",
              ref: contactUsFormRef,
              model: __props.contactUsForm.fields,
              size: __props.formSize,
              rules: contactUsFormRules
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.contactUsForm.fields, (props, field) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (props.isShow)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: field,
                          label: (props.type !== 'checkbox' && props.type !== 'placeHolder') ? props.label : '',
                          prop: field,
                          style: _normalizeStyle(props.type === 'placeHolder' ? 'width: 1px;' : ''),
                          class: _normalizeClass(props.type === 'textarea'|| props.id === 'inquiryPurpose' ? 'el-form-item-gridstyle' : ''),
                          onFocus: dispatchTrackInteraction
                        }, {
                          default: _withCtx(() => [
                            (props.type === 'input')
                              ? (_openBlock(), _createBlock(_component_el_input, {
                                  key: 0,
                                  modelValue: props.value,
                                  "onUpdate:modelValue": ($event: any) => ((props.value) = $event),
                                  class: _normalizeClass(props.isError ? 'validation-error' : ''),
                                  maxlength: "999",
                                  clearable: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]))
                              : _createCommentVNode("", true),
                            (props.type === 'select')
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 1,
                                  modelValue: props.value,
                                  "onUpdate:modelValue": ($event: any) => ((props.value) = $event),
                                  placeholder: " --- Please Select --- ",
                                  class: _normalizeClass(props.isError ? 'validation-error' : ''),
                                  filterable: "",
                                  multiple: Boolean(props.multipleSelect),
                                  "collapse-tags": Boolean(props.multipleSelect),
                                  "collapse-tags-tooltip": Boolean(props.multipleSelect),
                                  onFocus: dispatchTrackInteraction
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "class", "multiple", "collapse-tags", "collapse-tags-tooltip"]))
                              : _createCommentVNode("", true),
                            (props.type === 'textarea')
                              ? (_openBlock(), _createBlock(_component_el_input, {
                                  key: 2,
                                  type: "textarea",
                                  modelValue: props.value,
                                  "onUpdate:modelValue": ($event: any) => ((props.value) = $event),
                                  class: _normalizeClass(props.isError ? 'validation-error' : ''),
                                  maxlength: "999",
                                  autosize: { minRows: 5, maxRows: 8 },
                                  clearable: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["label", "prop", "style", "class"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256)),
                _withDirectives(_createVNode(_component_el_alert, {
                  class: "recaptcha-invalid-message",
                  title: recaptchaInvalidMessage.value,
                  type: "error"
                }, null, 8, ["title"]), [
                  [_vShow, recaptchaInvalid.value]
                ]),
                (formError.value)
                  ? (_openBlock(), _createBlock(_component_el_alert, {
                      key: 0,
                      class: "recaptcha-invalid-message",
                      title: "Please fill in required fields",
                      type: "error"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, { class: "submit-button" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      disabled: submitDisabled.value,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (onSubmit(contactUsFormRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" submit ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "size", "rules"])
          ], 512), [
            [_vShow, !submitted.value]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_el_card, {
              class: "post-submit-message",
              shadow: "hover"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, submitted.value]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})